<template>
	<el-dialog title="对账单详情" v-model="isDetail" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="page_warp">
			<div style="height: 170px;">
				<div class="rpt_tit">
					<p class="platTitle">对账信息</p>
				</div>
				<div class="info-input-container">
					<div class="flex flex-y-center flex-wrap">
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>对账单号：</span>
							</div>
							<span class="platItemRigth">{{loadWhNames}}</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>对账对象：</span>
							</div>
							<span class="platItemRigth">{{unlWhNames}}</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>对账单数：</span>
							</div>
							<span class="platItemRigth">{{timeDeltaCount(avgLoadDuration)}}</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>对账金额：</span>
							</div>
							<span class="platItemRigth">{{timeDeltaCount(avgUnlDuration)}}</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>装货总吨位：</span>
							</div>
							<span class="platItemRigth">{{timeDeltaCount(avgTravelDuration)}}</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>卸货总吨位：</span>
							</div>
							<span class="platItemRigth">{{timeDeltaCount(avgSumDuration)}}</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>核算总吨位：</span>
							</div>
							<span class="platItemRigth">{{avgFreewayCost}}</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>核算里程：</span>
							</div>
							<span class="platItemRigth">{{avgFuelCost}}</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>对账单附件：</span>
							</div>
							<span class="platItemRigth">{{avgSumCost}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="flex">
				<div class="rpt_tit">
					<p class="platTitle">对账明细
					</p>
				</div>
			</div>
			<div class="bottom_content">
				<div class="table_container" v-bind:id="tableId">
					<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="300"
						v-bind:header-cell-style="{
						  textAlign: 'center',
						  color: '#333333',
						  background: '#F5F5F5',
						}" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据">
						<el-table-column fixed prop="odrId" label="序号" width="120"></el-table-column>
						<el-table-column fixed prop="lorId" label="运单号" width="120"></el-table-column>
						<el-table-column fixed prop="shipperName" label="托运商" width="120"></el-table-column>
						<el-table-column fixed prop="lorVehHeadNo" label="牵引车辆" width="120"></el-table-column>
						<el-table-column prop="lorLoadName" label="装货地" width="120"></el-table-column>
						<el-table-column prop="unloadList[0].lorlUnlName" label="卸货地" width="120"></el-table-column>
						<el-table-column prop="lorFreightMilage" label="运费里程(KM)" width="120"></el-table-column>
						<el-table-column prop="lorFreightWeight" label="运费吨位(吨)" width="120"></el-table-column>
						<el-table-column prop="lorFreightPrice" label="运费单价(元/吨/公里)" width="120"></el-table-column>
						<el-table-column prop="lorFreightMoney" label="运费收入(元)" width="120"></el-table-column>
						<el-table-column prop="lorOccupyIncome" label="压车费收入(元)" width="120"></el-table-column>
						<el-table-column prop="lorUnloadIncome" label="分卸费收入(元)" width="120"></el-table-column>
						<el-table-column prop="lorSumIncome" label="总收入(元)" width="120"></el-table-column>
						<el-table-column prop="lorLoadsWeightSum" label="实际装货吨位" width="120"></el-table-column>
						<el-table-column prop="lorUnlsWeightSum" label="实际卸货吨位" width="120"></el-table-column>
						<el-table-column prop="lorLossWeightSum" label="途损吨位" width="120"></el-table-column>
						<el-table-column prop="lorLoadType" label="单/分卸" width="120">
							<template #default="scope">
								<span v-if="scope.row.lorLoadType == '0'">单装单卸</span>
								<span v-else-if="scope.row.lorLoadType == '1'">单装分卸</span>
								<span v-else>--</span>
							</template>
						</el-table-column>
						<el-table-column prop="lorGoods" label="货品" width="120">
							<template #default="scope">
								<span v-if="scope.row.lorGoods == '1'">LNG</span>
								<span v-else-if="scope.row.lorGoods == '2'">CNG</span>
								<span v-else>--</span>
							</template>
						</el-table-column>
						<el-table-column prop="odrMDirName" label="驾驶员" width="120"></el-table-column>
						<el-table-column prop="odrYayunName" label="押运员" width="120"></el-table-column>
						<el-table-column label="操作" fixed="right" width="100px">
							<template #default="scope">
								<span class="col-FF1A1A pointer">删除</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="flex flex-y-center flex-x-center m-top20">
					<el-config-provider :locale="locale">
						<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
							:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
							:total="totalCount" @size-change="getData" @current-change="getData" />
					</el-config-provider>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		computed,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isPhone,
		isIdNo
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	export default defineComponent({
		name: "Detail",
		// emits: ["getData"],

		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			// const getData = () => {
			// 	context.emit("getData");
			// };


			const data = reactive({
				tableId: "roleManagementTable",
				isDetail: false,
				index: 0,
				page: 1,
				pageSize: 10,
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				olseDefedit: false,
				olseDefeditisReadOnly: true,

				lineId: "20250609161228356",
				orgId: "TOP",
				odrType: "0",
				lineType: "0",
				odrCount: "1",
				whids: "14,16",
				whNames: "装货站点1,卸货站点1",
				loadWhids: "14",
				loadWhNames: "装货站点1",
				unlWhids: "16",
				unlWhNames: "卸货站点1",
				avgLoadDuration: 0,
				avgUnlDuration: 0,
				avgTravelDuration: 0,
				avgSumDuration: 0,
				avgFreewayCost: 0,
				avgTollCost: 0,
				avgFuelCost: 0,
				avgSumCost: 0,
				avgFreightMoney: 0,
				avgSumIncome: 0,
				avgSumMoney: 0,
				lineDefSet: null,
				olseRecNo: "",
				olseOrg: "TOP",
				olseDefDuration: "",
				olseDefMilage: "",
				olseDefGas: "",
				olseDefFuel: "",
				olseDefElectricity: "",
				olseDefTollCost: "",
				olseDefFreewayCost: "",
				olseCreator: "",
				olseCretime: "",
				olseModuser: "",
				olseModtime: "",

				permissionItem: {
					list: false,
					del: false,
					set: false,
					export: false,
				},

			});

			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "lineManage:list") {
						data.permissionItem.list = true;
					}
					if (el == "lineManage:del") {
						data.permissionItem.del = true;
					}
					if (el == "lineManage:set") {
						data.permissionItem.set = true;
					}
					if (el == "lineManage:export") {
						data.permissionItem.export = true;
					}
				});

				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight - 40;

				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
					});
				};
			});

			//重置数据
			const init = async (id) => {
				data.lineId = id;
				data.isDetail = true;
				console.log(id);
				// getDetail(id);
				data.olseDefedit = false;
				data.olseDefeditisReadOnly = true;

				let params = {
					lineId: data.lineId,
				};
				const r = await proxy.$http.get(apiObj.editLine, params);
				if (r) {
					data.orgId = r.data.orgId;
					data.odrType = r.data.odrType;
					data.lineType = r.data.lineType;
					data.odrCount = r.data.odrCount;
					data.whids = r.data.whids;
					data.whNames = r.data.whNames;
					data.loadWhids = r.data.loadWhids;
					data.loadWhNames = r.data.loadWhNames;
					data.unlWhids = r.data.unlWhids;
					data.unlWhNames = r.data.unlWhNames;
					data.avgLoadDuration = r.data.avgLoadDuration;
					data.avgUnlDuration = r.data.avgUnlDuration;
					data.avgTravelDuration = r.data.avgTravelDuration;
					data.avgSumDuration = r.data.avgSumDuration;
					data.avgFreewayCost = r.data.avgFreewayCost;
					data.avgTollCost = r.data.avgTollCost;
					data.avgFuelCost = r.data.avgFuelCost;
					data.avgSumCost = r.data.avgSumCost;
					data.avgFreightMoney = r.data.avgFreightMoney;
					data.avgSumIncome = r.data.avgSumIncome;
					data.avgSumMoney = r.data.avgSumMoney;
					if (r.data.lineDefSet === null || r.data.lineDefSet === undefined || r.data
						.lineDefSet === '') {
						data.lineDefSet = null;
						data.olseDefMilage = '';
						data.olseDefDuration = '';
						data.olseDefGas = '';
						data.olseDefFuel = '';
						data.olseDefElectricity = '';
						data.olseDefTollCost = '';
						data.olseDefFreewayCost = '';
					} else {
						data.lineDefSet = '1';
						data.olseDefMilage = r.data.lineDefSet.olseDefMilage;
						data.olseDefDuration = r.data.lineDefSet.olseDefDuration;
						data.olseDefGas = r.data.lineDefSet.olseDefGas;
						data.olseDefFuel = r.data.lineDefSet.olseDefFuel;
						data.olseDefElectricity = r.data.lineDefSet.olseDefElectricity;
						data.olseDefTollCost = r.data.lineDefSet.olseDefTollCost;
						data.olseDefFreewayCost = r.data.lineDefSet.olseDefFreewayCost;
					}
				}

				getData();
			};

			//获取列表数据
			const getData = async () => {
				let params = {
					page: data.page,
					limit: data.pageSize,
					lineId: data.lineId, //路线编号
				};
				const r = await proxy.$http.get(apiObj.lineOrderList, params);
				console.log(r);
				if (r.respCode == '0000') {
					data.tableData = r.rows;
					data.totalCount = r.total;
				}
			};


			const navClick = (index) => {
				data.index = index;
			};

			const dialogClosedHandle = () => {
				data.isDetail = false;
			};
			const closeModal = () => {
				data.isDetail = false;
			};

			const timeDeltaCount = function(time) {
				if (time) {
					var s = time % 60;
					var m = Math.floor(time / 60) % 60;
					var h = Math.floor(Math.floor(time / 60) / 60);

					if (h !== 0) {
						return h + "小时" + m + "分";
					}
					if (m !== 0) {
						return m + "分";
					}
					return s + "秒";
				} else {
					return ''
				}
			};

			const olseDefeditChange = (value) => {
				data.olseDefedit = value;
				data.olseDefeditisReadOnly = !value;

			};

			//编辑线路标准参数
			const olseDefeditsave = async () => {
				if (!data.permissionItem.set) {
					proxy.$message.error("没有线路标准设置权限！");
					return;
				}

				if (data.olseDefDuration == "" || data.olseDefDuration == null) {
					proxy.$message.error("请填写标准耗时");
					return;
				}
				if (data.olseDefMilage == "" || data.olseDefMilage == null) {
					proxy.$message.error("请填写标准里程");
					return;
				}
				if (data.olseDefGas == "" || data.olseDefGas == null) {
					proxy.$message.error("请填写标准气耗");
					return;
				}
				if (data.olseDefFuel == "" || data.olseDefFuel == null) {
					proxy.$message.error("请填写标准油耗");
					return;
				}
				if (data.olseDefTollCost == "" || data.olseDefTollCost == null) {
					proxy.$message.error("请填写标准路桥费");
					return;
				}
				if (data.olseDefFreewayCost == "" || data.olseDefFreewayCost == null) {
					proxy.$message.error("请填写标准高速费");
					return;
				}

				let params = {
					olseRecNo: data.lineId,
					olseDefDuration: data.olseDefDuration, //标准耗时
					olseDefMilage: data.olseDefMilage, //标准里程
					olseDefGas: data.olseDefGas, //标准气耗
					olseDefFuel: data.olseDefFuel, //标准油耗
					olseDefElectricity: 0, //标准电耗
					olseDefTollCost: data.olseDefTollCost, //标准路桥费
					olseDefFreewayCost: data.olseDefFreewayCost, //标准高速费
				};

				const r = await proxy.$http.post(apiObj.LineSetupdate, params)
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					init(data.lineId);
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};

			return {
				...toRefs(data),
				init,
				closeModal,
				dialogClosedHandle,
				getData,
				navClick,
				timeDeltaCount,
				olseDefeditChange,
				olseDefeditsave
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 600px;
	}

	.top_content {
		width: 100%;
		height: 70px;
		padding: 0 25px;
		margin-bottom: 10px;
		background: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
	}

	.bottom_content {
		width: 100%;
		height: calc(100% - 180px);
		background: #ffffff;
	}

	.bottom_content .table_container {
		width: calc(100% - 50px);
		height: calc(100% - 80px);
		margin: 0 auto;
		padding-top: 0px;
	}

	.nav_warp {
		width: 100%;
		height: 60px;
		background: #ffffff;
		border-bottom: 1px solid #eeeeee;
		display: flex;
		align-items: center;
	}

	.nav_item {
		position: relative;
		height: 78px;
		padding: 0 20px;
		margin-left: 50px;
		cursor: pointer;
	}

	.nav_item span {
		font-size: 18px;
		color: #666666;
		line-height: 78px;
	}

	.nav_item_ac span {
		color: #293787 !important;
	}

	.nav_item_line {
		position: absolute;
		width: 90%;
		left: 5%;
		height: 3px;
		background: #293787;
		bottom: 5px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		width: 50%;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 20px;
		font-size: 15px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
		padding-bottom: 10px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 0px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 100px;
		justify-content: flex-start;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.rpt_tit {
		width: 100%;
		height: 30px;
		text-align: left;
		font-weight: bold;
		line-height: 70px;
		font-size: 18px;
		color: #333333;
		text-indent: 0px;
		padding-bottom: 10px;
	}

	.editimg {
		width: 200px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-right: 10px;
		cursor: pointer;
		color: blue;
	}

	.editimg img {
		width: 14px;
		height: 15px;
		margin-right: 8px;
	}

	.auditwait {
		width: 35px;
		height: 16px;
		background: #0000ff;
		border-radius: 4px;
		text-align: center;
		line-height: 16px;
		font-size: 18px;
		color: #fff;
		padding: 0 5px;
		margin-left: 20px;
	}
</style>